export const sortByKey = (data,key) => {
  if(!data || !data.length) return [];
  return data.sort((a,b) => {
    if(typeof a[key] === "string") {
      return a[key].localeCompare(b[key]);
    }else {
      return b[key] - a[key];
    }
  });
}

export const formatLabel = (value) => {
  if (!value) return "";
  return value.length > 12 ? value.slice(0, 12) + "…" : value;
};